(function(){
  var header = document.querySelector('[data-bs-header]');
  if (!header) return;

  // --- Scrolled state ---
  var onScroll = function(){
    header.classList.toggle('is-scrolled', window.scrollY > 8);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // --- Dropdown bubbles ---
  var items = header.querySelectorAll('[data-bs-nav-item]');
  var openItem = null;
  var leaveTimer = null;

  var closeAll = function(){
    items.forEach(function(i){
      i.classList.remove('is-open');
      var bubble = i.querySelector('.bs-header__bubble');
      var btn = i.querySelector('[data-bs-dropdown-toggle]');
      if (bubble) bubble.setAttribute('hidden', '');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
    openItem = null;
  };

  items.forEach(function(item){
    var btn = item.querySelector('[data-bs-dropdown-toggle]');
    var bubble = item.querySelector('.bs-header__bubble');
    if (!btn || !bubble) return;

    var open = function(){
      if (openItem && openItem !== item) closeAll();
      item.classList.add('is-open');
      bubble.removeAttribute('hidden');
      btn.setAttribute('aria-expanded', 'true');
      openItem = item;
    };

    // Hover opens, leave closes (with small grace period to cross the gap).
    // leaveTimer is shared across all items so moving between nav items
    // cancels the previous item's pending close — otherwise the old timer
    // fires 120ms later and closes the freshly-opened dropdown.
    item.addEventListener('mouseenter', function(){
      clearTimeout(leaveTimer);
      open();
    });
    item.addEventListener('mouseleave', function(){
      clearTimeout(leaveTimer);
      leaveTimer = setTimeout(closeAll, 120);
    });

    // Click toggles (for touch devices that still show hover state)
    btn.addEventListener('click', function(e){
      e.preventDefault();
      if (item.classList.contains('is-open')) closeAll();
      else open();
    });

    // Keyboard focus opens
    btn.addEventListener('focus', open);
  });

  // --- Desktop search panel ---
  var searchToggle = header.querySelector('[data-bs-search-toggle]');
  var searchPanel = document.querySelector('[data-bs-search-panel]');
  var searchInput = searchPanel ? searchPanel.querySelector('input[type="search"]') : null;
  var isMobileHeader = function(){
    return window.matchMedia('(max-width: 900px)').matches;
  };

  var openSearch = function(){
    if (!searchPanel) return;
    closeAll();
    searchPanel.removeAttribute('hidden');
    requestAnimationFrame(function(){ searchPanel.classList.add('is-open'); });
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
    if (searchInput) setTimeout(function(){ searchInput.focus(); }, 50);
  };

  var closeSearch = function(){
    if (!searchPanel) return;
    searchPanel.classList.remove('is-open');
    setTimeout(function(){ searchPanel.setAttribute('hidden', ''); }, 200);
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
  };

  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function(e){
      e.preventDefault();
      if (isMobileHeader()) {
        closeSearch();
        if (typeof openDrawer === 'function') openDrawer('search');
        return;
      }
      if (searchPanel.hasAttribute('hidden')) openSearch();
      else closeSearch();
    });
  }

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') { closeAll(); closeSearch(); }
  });
  document.addEventListener('click', function(e){
    if (!header.contains(e.target)) { closeAll(); closeSearch(); }
  });

  // --- Mobile drawer ---
  var drawer = document.getElementById('bs-drawer');
  var backdrop = document.querySelector('[data-bs-drawer-backdrop]');
  var openBtn = document.querySelector('[data-bs-drawer-open]');
  var closeBtn = document.querySelector('[data-bs-drawer-close]');

  var openDrawer = function(focusTarget){
    if (!drawer || !backdrop) return;
    drawer.removeAttribute('hidden');
    backdrop.removeAttribute('hidden');
    requestAnimationFrame(function(){
      drawer.classList.add('is-open');
      backdrop.classList.add('is-open');
    });
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('bs-drawer-open');
    if (focusTarget === 'search') {
      setTimeout(function(){
        var drawerSearchInput = drawer.querySelector('input[type="search"]');
        if (drawerSearchInput) drawerSearchInput.focus();
      }, 260);
    }
  };

  var closeDrawer = function(){
    if (!drawer || !backdrop) return;
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    setTimeout(function(){
      drawer.setAttribute('hidden', '');
      backdrop.setAttribute('hidden', '');
    }, 240);
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('bs-drawer-open');
  };

  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') closeDrawer();
  });
})();
